/* tslint:disable */
/* eslint-disable */
/**
 * Melco Eod APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EodMelcoEodModelsScanRequest
 */
export interface EodMelcoEodModelsScanRequest {
    /**
     * 
     * @type {string}
     * @memberof EodMelcoEodModelsScanRequest
     */
    machine_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EodMelcoEodModelsScanRequest
     */
    device_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EodMelcoEodModelsScanRequest
     */
    bar_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EodMelcoEodModelsScanRequest
     */
    language?: string | null;
}

export function EodMelcoEodModelsScanRequestFromJSON(json: any): EodMelcoEodModelsScanRequest {
    return EodMelcoEodModelsScanRequestFromJSONTyped(json, false);
}

export function EodMelcoEodModelsScanRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): EodMelcoEodModelsScanRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'machine_name': !exists(json, 'machine_name') ? undefined : json['machine_name'],
        'device_id': !exists(json, 'device_id') ? undefined : json['device_id'],
        'bar_code': !exists(json, 'bar_code') ? undefined : json['bar_code'],
        'language': !exists(json, 'language') ? undefined : json['language'],
    };
}

export function EodMelcoEodModelsScanRequestToJSON(value?: EodMelcoEodModelsScanRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'machine_name': value.machine_name,
        'device_id': value.device_id,
        'bar_code': value.bar_code,
        'language': value.language,
    };
}


